var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_4653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.51203 16.4735L2.39406 18.0217C2.57734 18.3477 2.84078 18.6039 3.15008 18.7901C4.03602 17.6473 4.65258 16.7703 5.00008 16.1592C5.35266 15.539 5.78602 14.5688 6.30016 13.2489C4.91453 13.0635 3.86453 12.9708 3.15016 12.9708C2.46445 12.9708 1.41445 13.0635 0 13.2489C0 13.6097 0.0916406 13.9706 0.274922 14.2966L1.51203 16.4735Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.85 18.7901C17.1594 18.6039 17.4228 18.3477 17.606 18.0218L17.9726 17.3815L19.7253 14.2966C19.9051 13.9777 19.9999 13.6165 20.0001 13.2489C18.5774 13.0635 17.5294 12.9708 16.8558 12.9708C16.1319 12.9708 15.0838 13.0635 13.7114 13.2489C14.2195 14.5761 14.6471 15.5462 14.9944 16.1592C15.3446 16.7776 15.9631 17.6545 16.85 18.7901Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 6.7297C11.0252 5.47166 11.7316 4.50151 12.1193 3.81942C12.4316 3.27015 12.7753 2.39314 13.1503 1.18845C12.841 1.00219 12.4859 0.909058 12.1193 0.909058H7.88104C7.51447 0.909058 7.15947 1.01386 6.8501 1.18845C7.32713 2.57011 7.73197 3.55344 8.06447 4.13836C8.43197 4.7848 9.07721 5.64856 10.0002 6.7297Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7002 13.2489H6.30039L3.15039 18.7901C3.45961 18.9764 3.81469 19.0695 4.18125 19.0695H15.8194C16.1859 19.0695 16.5411 18.9647 16.8503 18.7901L13.7003 13.2489H13.7002Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 6.72977L6.85008 1.1886C6.5407 1.37486 6.27727 1.63092 6.09398 1.95692L0.274922 12.2012C0.0950098 12.5201 0.000237693 12.8813 0 13.2489H6.30016L10.0001 6.72977Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8156 7.07899L13.906 1.9568C13.7228 1.63079 13.4593 1.37474 13.15 1.18848L10 6.72972L13.6998 13.2489H19.9886C19.9886 12.888 19.897 12.5272 19.7137 12.2012L16.8156 7.07899Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_4653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveIcon);
export default __webpack_public_path__ + "static/media/driveIcon.46b7fe2b551d5ab2bb3e639c9eb2372c.svg";
export { ForwardRef as ReactComponent };